import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { useOutletContext } from 'react-router';

import { PARTNER_BRIGHTE_MODAL_FOOTER } from '~/constants';
import { OutletContextType } from '~/types/marketplace';

import { BrighteLogo } from './common/brighte-logo';

export const Footer = () => {
  const { partner } = useOutletContext<OutletContextType>();

  return (
    <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" gap="medium">
      <Text size="xsmall">{PARTNER_BRIGHTE_MODAL_FOOTER[partner ?? 'brighte'] ?? 'Powered by'}</Text>
      <BrighteLogo />
    </Box>
  );
};
